module.exports = __webpack_public_path__ + "static/img/teacher.b3e6a73b.png";